<template>
  <div class="news">
    <div class="bg">
      <div class="content">
        <h1>华云科技人工智能解决方案</h1>
        <p>面向教育、政务、医疗、企业的AI应用，助力AI+场景高效落地</p>
        <button class="learn-more">了解更多</button>
      </div>
    </div>
    <div class="main">
      <div class="breadcrumb">
        <a href="/">首页</a>
        <span> &gt; </span>
        <span class="current">新闻资讯</span>
      </div>

      <div class="news-list">

        <h2>新闻动态</h2>
        <div class="news-item" v-for="(news, index) in newsList" :key="index" @click="handleDetail(index)">
            <div class="news-text">
              <h3>{{ news.title }}</h3>
              <p class="date">{{ news.date }}</p>
              <p>{{ news.content }}</p>
            </div>
            <div class="news-image">
              <img :src="news.img" alt="新闻图片">
            </div>

        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script setup>
import { ref } from 'vue';
import Footer from "@/components/Footer";
import { useRouter } from 'vue-router';

const router = useRouter();

const imageUrl = require('@/assets/news/news_img.jpg');
const imageUrl1 = require('@/assets/news/news1.jpeg');
const imageUrl2 = require('@/assets/news/news2.jpeg');
const imageUrl3 = require('@/assets/news/news3.webp');
const imageUrl4 = require('@/assets/news/news4.webp');
const imageUrl5 = require('@/assets/news/news5.webp');
const imageUrl6 = require('@/assets/news/news6.webp');
const imageUrl7 = require('@/assets/news/news7.webp');
const imageUrl8 = require('@/assets/news/news8.webp');
const imageUrl9 = require('@/assets/news/news9.webp');
const imageUrl14 = require('@/assets/news/news14.webp');
const imageUrl31 = require('@/assets/news/news31.webp');
const imageUrl35 = require('@/assets/news/news35.webp');
const imageUrl42 = require('@/assets/news/news42.webp');
const imageUrl46 = require('@/assets/news/news46.webp');
const imageUrl51 = require('@/assets/news/news51.webp');
const imageUrl61 = require('@/assets/news/news61.webp');
const imageUrl68 = require('@/assets/news/news68.webp');
const imageUrl73 = require('@/assets/news/news73.webp');
const imageUrl74=require('@/assets/news/news81.jpeg');
const imageUrl83 = require('@/assets/news/news83.webp');
const imageUrl84 = require('@/assets/news/news84.webp');
const imageUrl85 = require('@/assets/news/news85.jpg');
const imageUrl86 = require('@/assets/news/news86.webp');
const imageUrl87 = require('@/assets/news/news87.webp');
const imageUrl88 = require('@/assets/news/news88.webp');
const imageUrl89 = require('@/assets/news/news89.webp');
const imageUrl90 = require('@/assets/news/news90.webp');
const imageUrl92 = require('@/assets/news/news92.webp');

const handleDetail=(index)=>{
  router.push(`/newsDetail?index=${index}`)
}

const newsList = ref([
  {
    title: '华云科技亮相东博会，与南宁市马山县签署AI+教育领域战略合作',
    date: '华云 2026年9月22日',
    content: `近日，第23届中国—东盟博览会、中国—东盟商务与投资峰会期间，马山县县委、县政府举办专题推介活动，以"AI+产教融合"为核心。华云科技与马山县教育局签署"人工智能赋能教育及县域多领域发展战略合作项目"，双方将围绕AI进校园、数字技能人才培养、县域多领域数字化转型等方向开展深度合作。`,
    img: imageUrl92
  },
  {
    title: '华云科技亮相广东联通2026数智创新暨合作伙伴大会，携手共建AI+政企新生态',
    date: '华云 2026年3月28日',
    content: `3月27日下午，广东联通2026数智创新暨合作伙伴大会在广州成功举办。本次大会以"向实同行·行稳至远"为主题，华云科技作为广东联通在AI应用领域的战略ISV伙伴重磅亮相。`,
    img: imageUrl86
  },
  {
    title: '华云科技 × 华为｜人工智能教学中心（AIEC）解决方案正式发布！',
    date: '华云 2026年3月20日',
    content: `在AI时代，教育变革的浪潮下，人工智能正成为重构教学场景、赋能人才培养的核心引擎。3月19日，华为联合华云科技及生态伙伴，在华为中国合作伙伴大会2026正式发布人工智能教学中心（AIEC）解决方案，以技术之力为教育行业注入全新动能，助力学校打造智能、高效、普惠的现代化教学场景。`,
    img: imageUrl83
  },
  {
    title: '中国教科院官媒专题推介！深圳南山人工智能高质量示范课堂',
    date: '华云 2025年11月29日',
    content: `近日，在深圳市南山区教育科学研究院指导下，华云科技与南山外国语学校（集团）科华学校联合打造的AI赋能素养课例《南极零碳科考站设计》，亮相中国教育科学研究院交流活动并获专家高度评价。`,
    img: imageUrl74
  },
  {
    title: '龙外（集团）专属AI平台正式发布，开启集智共生数智生态新篇章',
    date: '华云 2025年10月27日',
    content: `智启未来，育见新篇。近日，深圳市龙岗区外国语学校（集团）成功举办集团专属AI平台发布会。集团领导、师生代表与技术研发团队齐聚一堂，共同见证这一赋能教育高质量发展的里程碑时刻。
    `,
    img: imageUrl73
  },
  {
    title: 'AI赋能教育，智启教学新篇——深圳实验坪山学校AI大模型操作培训会圆满举办',
    date: '华云 2025年10月27日',
    content: `在人工智能技术迅猛发展的今天，AI 大模型正深刻改变着教育教学的形态。近期，深圳实验教育集团正式上线“深实验种子”AI大模型平台，作为献给全体师生的智能教育献礼。

10 月 18 日下午，深圳实验坪山学校在六楼学术报告厅组织操作培训会，对“深实验种子”AI 大平台进行深入学习。`,
    img: imageUrl68
  },
  {
  title: '实时盯学情、个性化提分？国华以AI赋能教育新变革',
  date: '华云 2025年10月25日',
  content:`当国华遇上前沿 AI，会碰撞出怎样的教育新火花？
  近日，国华纪念中学与深圳华云科技研发有限公司旗下华云天图平台举行战略合作签约仪式，此次合作旨在为学校培养创新型人才、提升教学质量提供协助，也意味着学校将前沿AI技术与优质教育理念深度融合，在智慧校园建设与AI教育应用领域不断探索。
  `,
  img: imageUrl61
},
{
  title: '【聚力融合共生 美美与共】以智慧点亮心灯 用科技赋能教育 ——深圳实验学校初中部教师队伍建设系列专题培训',
  date: '深圳实验学校初中部 2025年10月25日',
  content:`为提升教师专业素养，赋能教师成长。深圳实验学校初中部围绕教师能力发展、学校课程体系构建与人工智能教育融合及校园文化宣传工作等方面，开展了专题培训，系统推进教师队伍建设，为教育教学质量提升注入持续动能。
  `,
  img: imageUrl51
},
{
    title: '为AI时代高中教育高质量发展探新路 | 全国百余名中学书记、校长走进宝中',
    date: '华云 2025年9月26日',
    content: '日前，普通高中校长年会（2025）在广东深圳举办，吸引了全国2000余名教育专家学者，高中书记、校长及教师代表齐聚一堂，共商人工智能背景下高中教育的变革与创新。',
    img: imageUrl46
  },
{
    title: '华云科技获评PIA二星级标识，以安全合规筑牢 AI 服务基石',
    date: '华云 2025年9月18日',
    content: '日前，深圳华云科技研发有限公司荣获由“中国网络安全产业联盟（CCIA）数据安全工作委员会”颁发的 “PIA标识”认证。该认证项目由国家互联网信息办公室指导，中国通信标准化协会、中国信息通信研究院主持评审，是国内个人信息保护领域首个官方权威认证。',
    img: imageUrl42
  },
  {
    title: '教师节献礼！深实验AI大模型"种子" 平台正式启动，为教师减负，为成长赋能',
    date: '华云 2025年9月12日',
    content: '当人工智能与教育深度碰撞，会绽放出怎样的火花？9月10日（第41个教师节）深圳实验教育集团联合华为、华云科技，正式推出深实验AI大模型"种子"平台！这不仅是我们在智慧教育赛道上的全新突破，更是践行"人格是最高学位 育人宗旨、用科技赋能教育的生动实践。',
    img: imageUrl35
  },
{
    title: '华云科技打造"华云天图AI平台"亮相"科学教育·社会协同"资源对接交流活动——多区域AI实践聚力，共筑教育协同新生态',
    date: '华云 2025年2月24日',
    content: '在"科学教育·社会协同"资源对接交流活动中，华云科技与比亚迪、华大集团、教育研修院等企业代表共同与深圳市教育局进行了签约仪式，承诺通过"每周半天活动"服务，推动科学教育高质量发展。同时，华云科技与腾讯、科大讯飞等二十余家企业共同参与了捐赠仪式，以实际行动践行企业社会责任，支持教育资源的开放与共享。华云科技依托人工智能、芯片、云计算等技术，赋能教育场景创新，为构建开放共享、公平优质的现代化教育贡献力量。 ',
    img: imageUrl14
  },
  {
    title: '双奖加冕！昇腾+DeepSeek，华云科技打造每一组织迈向AI时代的最佳实践',
    date: '华云 2025年2月24日',
    content: '在智能化浪潮奔涌的2024年，华为广东合作伙伴大会于珠海圆满落幕。这场汇聚1385位政企精英、数字能源伙伴、行业专家及生态领袖的盛会，不仅见证了华为与伙伴们"同心同行"的坚定步伐，更以"粤战粤勇"的魄力，为AI时代的产业升级注入澎湃动能。在这场高规格盛典中，华云科技凭借在人工智能的深耕与突破，一举斩获"最佳解决方案优秀伙伴奖"与"人才生态建设奖"双项殊荣。',
    img: imageUrl31
  },
  {
    title: '新教育、华为、华云科技全面合作签约',
    date: '华云 2023年12月28日',
    content: '12月28日上午，苏州大学新教育研究院人工智能未来教育研究所正式成立。华为云全球生态部总裁康宁、华为云教育解决方案总经理唐国军、 华为云云学堂总经理李亮、华为云江苏副总经理郭剑、华为云生态伙伴发展总监王静涛;中陶会新教育专委会理事长许新海、新 教育研究院院长李镇西、新教育研究院办公室主任杜涛、苏州大学新教育研究院副院长郭小月、新网师执行主任郝晓东;深圳华 云科技研发有限公司董事长肖平、总经理李妙丽等参加仪式。',
    img: imageUrl
  },
  {
    title: '这个生成式AI作业系统好神奇！小小作业本里的“智能变革',
    date: '华云 2024年05月12日',
    content: `减作业是减负最直接也是最重要的一个指标，“双减”之下作业如何“减量提质”？怎样才能做到“减负不减分”？单科老师如何辅导全学段作业？如何有效减少家长负担，提升家长满意度？宝安区西湾小学率先试运行国内首个AIGC生成式人工智能作业系统已有半年多时间，这套“AI作业系统”显然已经获得了老师孩子们的认可。据介绍，这套诞生于深圳的人工智能作业系统行将从西湾小学走向深圳乃至全国。我们习以为常的小小的作业本，可能迎来一场教育的“智能变革”。`,
    img: imageUrl1
  },
  {
    title: '【人工智能】王红部长受邀在全国基础教育管理服务平台应用培训会上作《人工智能：让教育回归真正的教育》专题讲座',
    date: '华云 2024年7月20日',
    content: '7月10日至12日，2024年全国基础教育管理服务平台应用培训班在华南师范大学汕尾校区举行。本次培训班由教育部基础教育司指导、教育部教育管理信息中心主办、华南师范大学承办，旨在加快推进全国基础教育管理服务平台全面应用，提升学校教育信息化管理水平，赋能基础教育高质量发展。教育部基础教育司、教育部教育管理信息中心、华南师范大学、汕尾市教育局有关领导以及来自全国各省（直辖市、自治区）省级教育行政部门、部分县区教育局干部、中小学老师、企业代表等约200人参会。',
    img: imageUrl3

  },
  {
    title: '人才是技术发展的源头活水，华为云携手伙伴为人才培养探新路！',
    date: '华云 2024年6月27日',
    content: '在刚刚过去的华为开发者大会2024上，丰富多样的主题演讲、峰会、专题论坛，以及数百场面向开发者的特色体验活动，都成为最近互联网从业者高频讨论的话题。其中，垂直教育领域的“云商店助力智慧教育数字化转型 探索人工智能与教育信息化融合创新”专题论坛，邀约教育领域专家、学校、教育行业企业，共同就教育智能化升级展开了积极讨论。',
    img: imageUrl9
  },
]);
</script>

<style scoped lang="scss">
.news {
  width: 100%;


  .bg {
    width: 100%;
    height: 630px;
    background-image: url("@/assets/news/bg.png");
    background-size: cover;
    background-position: center;
    display: flex;
    padding-left: 250px;
    box-sizing: border-box;
    align-items: center;

    .content {
      text-align: left;
      color: #fff;

      h1 {
        font-size: 48px;
        font-weight: bold;
        margin-bottom: 20px;
      }

      p {
        font-size: 18px;
        margin-bottom: 30px;
      }

      .learn-more {
        background-color: #c71b24;
        color: #fff;
        border: none;
        padding: 10px 20px;
        font-size: 16px;
        cursor: pointer;
        border-radius: 30px;
      }
    }
  }

  .main {
    background-color: #f4f5f7;
    padding: 0 250px;

    .breadcrumb {
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #636262;
      height: 160px;
      padding-top: 50px;
      box-sizing: border-box;


      a {
        text-decoration: none;
        color: #636262;
      }

      span {
        margin: 0 15px;
      }

      .current {
        padding: 0;
        margin: 0;
      }
    }



    .news-list {
      width: 100%;
      margin-top: 20px;

      h2 {
        text-align: center;
        margin-bottom: 20px;
        font-size: 2rem;
        font-weight: bold;
        margin-bottom: 130px;
      }

      .news-item {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        padding-bottom: 60px;
        border-bottom: 1px solid #e2e3e3;

        .news-text {
          flex: 1;
          margin-right: 20px;
          cursor: pointer;

          h3 {
            font-size: 1.5rem;
            margin-bottom: 10px;
            font-weight: 400;
          }

          .date {
            font-size: 1rem;
            color: #888;
            margin-bottom: 30px;
          }

          p {
            font-size: 1rem;
            line-height: 2;
            color: #565352;
          }
        }

        .news-image {
          cursor: pointer;
          width: 350px;
          height: 100%;
          overflow: hidden;
          margin-left: 90px;
          padding-top: 24px;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
      }
    }
  }

  @media (max-width: 1440px) {
    .bg {
      padding-left: 150px;

      .content {
        h1 {
          font-size: 40px;
        }

        p {
          font-size: 16px;
        }
      }
    }

    .main {
      padding: 0 150px;

      .news-list {
        .news-item {
          .news-image {
            width: 300px;
            margin-left: 60px;
          }
        }
      }
    }
  }

  @media (max-width: 1280px) {
    .bg {
      padding-left: 100px;

      .content {
        h1 {
          font-size: 36px;
        }

        p {
          font-size: 14px;
        }
      }
    }

    .main {
      padding: 0 100px;

      .news-list {
        .news-item {
          .news-image {
            width: 250px;
            margin-left: 40px;
          }
        }
      }
    }
  }

  @media (max-width: 1080px) {
    .bg {
      padding-left: 50px;

      .content {
        h1 {
          font-size: 32px;
        }

        p {
          font-size: 12px;
        }
      }
    }

    .main {
      padding: 0 50px;

      .news-list {
        .news-item {
          flex-direction: column;

          .news-text {
            margin-right: 0;
            margin-bottom: 20px;
          }

          .news-image {
            width: 100%;
            margin-left: 0;
          }
        }
      }
    }
  }
}
</style>
